import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pp',
  templateUrl: './pp.component.html',
  styleUrls: ['./pp.component.scss']
})
export class PpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
